/**
 * Expand and collapse elements
 * @module app/components/BodyStateAdapter
 */
import jQuery from 'jquery';
import DeviceDetector from './DeviceDetector';

var $body = jQuery('body');

/**
 * Public functions.
 *
 * @type {Object}
 *
 * @public
 */
var api = {

    /**
     * Sets up drop Down / toggle menus
     *
     * @param jQuery jQuery
     * @param page Page
     * @param sport Sport
     *
     * @returns {void}
     *
     * @public
     */
    init: function (jQuery, page, sport) {
        $body.attr('data-page', page);
        $body.attr('data-sport', sport);
        if(DeviceDetector.isMobile()) {
            if ( page === 'home') {
                jQuery('html').removeClass('header-no-product-menu');
            } else {
                jQuery('html').addClass('header-no-product-menu');
            }
        }
    },

    /**
     * Toggles scrolling on the body element
     *
     * @param disable
     *
     * @returns {void}
     *
     * @public
     */
    toggleBodyScrolling: function toggleBodyScrolling(disable) {

        $body.toggleClass('-unscrollable', disable);

    },
};

export default api;
